
























import Vue from 'vue';
import MStoreRadioButtonGroup from './MStoreRadioButtonGroup.vue';
import { FormFieldValidation } from '@/mixins';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'MStoreFormRadioButtonGroup',
  mixins: [FormFieldValidation],
  props: {
    id: {
      type: String
    },
    value: {
      required: true
    },
    options: {
      required: true,
      type: Array
    },
    valueField: {
      default: 'value',
      type: String
    },
    textField: {
      default: 'text',
      type: String
    },
    fieldName: {
      required: true,
      type: String
    },
    label: {
      type: String,
      default: null
    },
    validation: {
      default: {},
      type: Object as () => ValidationModel
    }
  },
  computed: {
    inputValue: {
      get(this: any) {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      }
    }
  },
  components: {
    MStoreRadioButtonGroup
  }
});
